import React from 'react';
import PropTypes from 'prop-types';
import Button from '@strava/ui/Button';
import Spinner from '@strava/ui/Spinner';

import createNetworkingClient from 'utils/networking-client';
import I18n from 'utils/I18n';

import EmailInput from '../EmailInput';

import styles from './styles.scss';

const I18nPrefix = 'strava.challenges.challenge_detail';

class Email extends React.Component {
  state = {
    submitRequested: false,
    submitSucceeded: false,
    errorMessage: '',
    successMessage: '',
    addresses: []
  };

  handleAddressesChange = (addresses) => {
    if (!addresses) {
      this.setState({ addresses: [] });
      return;
    }
    const emails = addresses.map((address) => address.value);
    this.setState({ addresses: emails });
  };

  handleSubmit = () => {
    const { addresses } = this.state;
    const { challengeId, challengeName, currentAthlete } = this.props;

    this.setState({ submitRequested: true });

    const message = I18n.t(`${I18nPrefix}.invite_message`, {
      athleteName: currentAthlete.name,
      challengeName
    });

    const instance = createNetworkingClient();

    instance
      .post(`/challenges/${challengeId}/share/send_email`, {
        emails: addresses,
        message
      })
      .then((response) => {
        if (response && response.status === 200) {
          this.onSubmitSuccess(response.data);
        } else {
          this.onSubmitFail();
        }
      })
      .catch(() => {
        this.onSubmitFail();
      });
  };

  onSubmitSuccess = () => {
    this.setState({
      submitRequested: false,
      submitSucceeded: true,
      errorMessage: '',
      successMessage: I18n.t(`${I18nPrefix}.success_message`)
    });

    setTimeout(() => {
      const { closeModal } = this.props;
      closeModal();
    }, 2000);
  };

  onSubmitFail = () => {
    this.setState({
      submitRequested: false,
      errorMessage: I18n.t(`${I18nPrefix}.error_message`)
    });
  };

  renderMessage = () => {
    const { errorMessage, successMessage } = this.state;

    if (errorMessage) {
      return (
        <h2 className={`${styles.message} ${styles.error}`}>{errorMessage}</h2>
      );
    }

    if (successMessage) {
      return (
        <h2 className={`${styles.message} ${styles.success}`}>
          {successMessage}
        </h2>
      );
    }

    return null;
  };

  render() {
    const { addresses, submitRequested, submitSucceeded } = this.state;
    const { challengeName, currentAthlete } = this.props;

    return (
      <>
        {this.renderMessage()}
        {submitRequested ? (
          <div className={styles.spinner}>
            <Spinner />
          </div>
        ) : (
          !submitSucceeded && (
            <div>
              <div className={styles.aboveInput}>
                {I18n.t(`${I18nPrefix}.to`)}
                <span className={`text-caption2 ${styles.limit}`}>
                  {I18n.t(`${I18nPrefix}.limit`)}
                </span>
              </div>
              <div className={styles.selectInput}>
                <EmailInput
                  handleAddressesChange={this.handleAddressesChange}
                />
              </div>
              <div>
                <div>{I18n.t(`${I18nPrefix}.message`)}</div>
                <div className="text-callout">
                  {I18n.t(`${I18nPrefix}.invite_message`, {
                    athleteName: currentAthlete.name,
                    challengeName
                  })}
                </div>
              </div>
              <Button
                key="invite"
                variant="primary"
                disabled={addresses.length === 0 || submitRequested}
                onClick={this.handleSubmit}
                className={`btn btn-sm ${styles.submitButton}`}
              >
                {I18n.t(`${I18nPrefix}.invite`)}
              </Button>
            </div>
          )
        )}
      </>
    );
  }
}

Email.propTypes = {
  closeModal: PropTypes.func.isRequired,
  challengeId: PropTypes.number.isRequired,
  currentAthlete: PropTypes.shape({
    name: PropTypes.string.isRequired
  }).isRequired,
  challengeName: PropTypes.string.isRequired
};

export default Email;
